import { socket } from "@randajan/simple-app/fe";
import BifrostClient from "@randajan/bifrost/client";



export const bifrost = new BifrostClient(socket);
